import { makeStyles } from '@mui/styles';
import { Theme } from '@mui/material/styles';
import { Colors } from '../../assets/styles';

const useStyles = makeStyles((theme: Theme) => {
  const pxToRem = (px: number): string => `${px / 16}rem`;

  return {
    components: {
      MuiListItem: {
        styleOverrides: {
          root: {
            paddingLeft: '16px',
            paddingRight: '16px',
            backgroundColor: 'transparent',
            '&:hover': {
              backgroundColor: 'rgba(255, 255, 255, 0.1)',
            },
          },
        },
      },
    },
    container: {
      minWidth: 74,
      backgroundImage: `linear-gradient(${Colors.Blue2}, ${Colors.Green1})`,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      minHeight: '100vh',
    },
    containerExpanded: {
      width: 220,
      paddingTop: 25,
      '& $listItem': {
        padding: `${pxToRem(37)} 0`,
      },
      '& $logo': {
        paddingBottom: 20,
        width: '100%',
      },
    },
    logo: {
      width: 58,
    },
    list: {
      width: '100%',
    },
    listItem: {
      display:'flex',
      flexDirection: 'column',
      padding: `${pxToRem(20)} 0`,
    },
    listItemSelected: {
      backgroundColor: 'rgba(0,0,0,0.25)',
    },
    listItemText: {
      '&.MuiTypography-root':{
        color: `${Colors.White} !important`,
        marginTop: 14,
      }
    },
    listItemIcon: {
      width: 24,
      height: 24,
    },
    listItemRoot:{
      display:'flex',
      flexDirection:'column',
    }
  };
});

export default useStyles;
